import { Box, styled, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import BaseInput from './BaseInput';
import { Eye, EyeSlash } from 'iconsax-react';

const EyeCustom = styled(Eye)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(3.5),
  right: theme.direction === 'ltr' ? theme.spacing(4) : 'auto',
  left: theme.direction === 'rtl' ? theme.spacing(4) : 'auto',
  cursor: 'pointer',
  [theme.breakpoints.down('md')]: {
    top: theme.spacing(2.5),
  },
}));
const EyeSlashCustom = styled(EyeSlash)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(3.5),
  right: theme.direction === 'ltr' ? theme.spacing(4) : 'auto',
  left: theme.direction === 'rtl' ? theme.spacing(4) : 'auto',
  cursor: 'pointer',
  [theme.breakpoints.down('md')]: {
    top: theme.spacing(2.5),
  },
}));

const PasswordInput = ({
  type = 'text',
  placeholder = '',
  onChange = '',
  value = '',
  ErrorInput = false,
  name = '',
  onBlur = '',
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box sx={{ position: 'relative' }}>
      <BaseInput
        type={showPassword ? 'text' : type}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        ErrorInput={ErrorInput}
        name={name}
        sx={{
          pr: (theme) => (theme.direction === 'ltr' ? 12 : 4),
          pl: (theme) => (theme.direction === 'rtl' ? 12 : 4),
        }}
        onBlur={onBlur}
      ></BaseInput>
      {!showPassword ? (
        <EyeCustom
          size={mdDown ? '20px' : '24px'}
          onClick={() => setShowPassword((prev) => !prev)}
        />
      ) : (
        <EyeSlashCustom
          size={mdDown ? '20px' : '24px'}
          onClick={() => setShowPassword((prev) => !prev)}
        />
      )}
    </Box>
  );
};
export default PasswordInput;
